import { ThirdPartyAccountLinkageTrackingPoint } from '@shopee-user/tracking-constants';

import { PageType } from '../constants';

const ThirdPartyAccountLinkageTrackingSchema: Record<
  ThirdPartyAccountLinkageTrackingPoint,
  string
> = {
  [ThirdPartyAccountLinkageTrackingPoint.PageView]:
    '32598aff-9157-4057-bd5c-1c614c1bed3e',
  [ThirdPartyAccountLinkageTrackingPoint.LinkWithThirdPartyGoogle]:
    '0d8629bf-a1f7-41cf-a052-4b8c20e0b02e',
  [ThirdPartyAccountLinkageTrackingPoint.LinkWithThirdPartyFacebook]:
    'b6349c9c-da99-4354-8b76-623b70e92128',
  [ThirdPartyAccountLinkageTrackingPoint.LinkWithThirdPartyApple]:
    '3aa45447-49dd-4732-ac35-137efbd48e8e',
  [ThirdPartyAccountLinkageTrackingPoint.LinkWithThirdPartyShopee]:
    'dc4b721d-2f55-4774-b159-b8fb34275d04',
  [ThirdPartyAccountLinkageTrackingPoint.LinkWithThirdPartySuccessAction]:
    '66cc2ee6-7d5b-4ff0-a52d-68ecc1c4e94d',
  [ThirdPartyAccountLinkageTrackingPoint.LinkWithThirdPartyFailAction]:
    '70deb9d5-65ba-450e-a2ae-8375b41db29a',
  [ThirdPartyAccountLinkageTrackingPoint.UnlinkWithThirdPartyPopupView]:
    '8ce7e65c-1291-409f-aaca-03bdf9156d15',
  [ThirdPartyAccountLinkageTrackingPoint.UnlinkWithThirdPartyConfirmClick]:
    '5e93ce6f-7451-4f16-88c5-d260be225586',
  [ThirdPartyAccountLinkageTrackingPoint.UnlinkWithThirdPartyCancelClick]:
    'f91795ec-9b4e-4466-b8ab-05eedb914335',
};

export const getThirdPartyAccountLinkagePageTypeAndSchema = (
  trackingPoint: ThirdPartyAccountLinkageTrackingPoint
) => {
  return {
    page_type: PageType.ThirdPartyAccountLinkagePage,
    schema: ThirdPartyAccountLinkageTrackingSchema[trackingPoint],
  };
};
